export default __webpack_public_path__ + "static/media/CNo.80-5.698d6ae6.jpg";